module.exports = __webpack_public_path__ + "img/bsc_01.60d8b799.png";